import { createContext } from 'react';

import { SettingsProviderProps } from './types';

export const SettingsContext = createContext<SettingsProviderProps>({
  appSettings: { isTabsShown: false },
  setAppSettings: () => {},
  projects: null,
  setProjects: () => {},
  currentProject: null,
  setCurrentProject: () => {},
  currentSocials: null,
  setCurrentSocials: () => {},
  platformSettings: null,
  setPlatformSettings: () => {},
  merchantProjects: null,
  setMerchantProjects: () => {},
  notifyState: [],
  setNotifyState: () => {},
  checklistItems: null,
  setChecklistItems: () => {},
  setBabkaLoginClient: () => {},
  babkaLoginClient: null,
  setShowBabkaLogin: () => {},
  showBabkaLogin: false
});
